module.exports = __webpack_public_path__ + "img/alphascience.2046f95a.svg";